import { render, staticRenderFns } from "./DocumentEditForm.vue?vue&type=template&id=443c611f&"
import script from "./DocumentEditForm.vue?vue&type=script&lang=js&"
export * from "./DocumentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports